import { SystemState } from '../system/SystemState';
import { RootState } from '../configureStore';

// Main selector for system alerts with fallback for empty state
export const selectSystemAlerts = (state: RootState) =>
  state.reporting?.latestSystemAlerts || [];

// Selector to get a specific alert by ID
export const selectSystemAlertById = (state: RootState, id: string) =>
  selectSystemAlerts(state).find(alert => alert.id === id);
